export const handleChangeDataChargeWalletPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_CHARGE_WALLET', name, value
});